export default __webpack_public_path__ + "static/media/about-part-1-2.0d9e790e.png";